import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    *{
        font-family:'metropolis';
    }

    :root{
        --color--primary:red;
    }
    .flex {
        display: flex;
    }

    .noBorder {
        border-color: #FFF;
        border-width: 0;
    }

    .projectGreen {
        background-color: #00984A;
    }

    .projectDarkGray {
        color: #6D6D6D
    }

    .col {
        flex-direction: column;
    }
`;

export default GlobalStyle;
